// src/pages/Home.jsx
import { useEffect, useMemo, useState } from "react";
import { SITE, SERVICES } from "../data/site";
import { Link } from "react-router-dom";
import { setPageSeo } from "../utils/seo";

/* ---------- icons (no extra library needed) ---------- */
function IconShield(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M12 2l7 4v6c0 5-3 9-7 10C8 21 5 17 5 12V6l7-4z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 12l1.8 2L15 10"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function IconWrench(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M21 7a6 6 0 01-8 5.7L8.7 17l-2.7-2.7 4.3-4.3A6 6 0 0117 3l-3 3 4 4 3-3z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function IconBolt(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M13 2L3 14h8l-1 8 11-14h-8l0-6z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function IconChat(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M21 12a8 8 0 01-8 8H7l-4 2 1.5-4A8 8 0 1121 12z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M8 12h8M8 8h5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}
function IconArrowLeft(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M15 18l-6-6 6-6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function IconArrowRight(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M9 6l6 6-6 6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function IconChevronDown(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M6 9l6 6 6-6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function IconBuilding(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M4 21V3h10v18M14 8h6v13"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M7 7h3M7 11h3M7 15h3M16 12h2M16 16h2"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}
function IconHome(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M3 10.5L12 3l9 7.5V21H3v-10.5z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M9 21v-7h6v7"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function IconFactory(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M3 21V10l6 3V10l6 3V10l6 3v8H3z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M7 21v-4h3v4M14 21v-6h3v6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function IconLayers(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M12 3l9 5-9 5-9-5 9-5z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M3 12l9 5 9-5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M3 16l9 5 9-5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function IconCheckCircle(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M12 22a10 10 0 110-20 10 10 0 010 20z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M8.2 12.2l2.2 2.2 5.5-5.6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function IconClipboard(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M9 4h6l1 2h3v16H5V6h3l1-2z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M9 4a3 3 0 006 0"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M8 11h8M8 15h8"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}
function IconPin(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M12 21s7-5.1 7-11a7 7 0 10-14 0c0 5.9 7 11 7 11z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      <path
        d="M12 11.2a2.2 2.2 0 110-4.4 2.2 2.2 0 010 4.4z"
        fill="currentColor"
      />
    </svg>
  );
}
function IconStar(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M12 2l2.7 6.4 6.9.6-5.2 4.5 1.6 6.7L12 17.8 6 20.2l1.6-6.7L2.4 9l6.9-.6L12 2z"
        fill="currentColor"
      />
    </svg>
  );
}
function IconQuestion(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M12 22a10 10 0 110-20 10 10 0 010 20z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M9.7 9a2.6 2.6 0 015.1.8c0 1.7-1.4 2.2-2.2 2.7-.7.4-.8.6-.8 1.5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M12 17h.01"
        stroke="currentColor"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
    </svg>
  );
}
function classNames(...xs) {
  return xs.filter(Boolean).join(" ");
}

export default function Home() {
  useEffect(() => {
    setPageSeo({
      title: "Awning & Roofing Contractor Singapore | Din Lee Engineering",
      description:
        "Din Lee Engineering Pte. Ltd. provides retractable awning, rooftop awnings, polycarbonate roof, ACP roof, zip track, roller blinds, metal works and shade solutions in Singapore.",
      canonical: `${SITE.domain}/`,
    });
  }, []);

  /* ---------- Inject marquee CSS reliably (works in CRA) ---------- */
  useEffect(() => {
    const id = "dlee-marquee-style";
    if (document.getElementById(id)) return;
    const style = document.createElement("style");
    style.id = id;
    style.textContent = `
      @keyframes dleeMarquee {
        0% { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
      .dleeMarqueeTrack {
        display:flex; gap:16px; width:max-content;
        animation: dleeMarquee 35s linear infinite;
      }
      .dleeMarqueeWrap:hover .dleeMarqueeTrack { animation-play-state: paused; }
      @media (max-width: 640px) {
        .dleeMarqueeTrack { animation-duration: 55s; }
      }
    `;
    document.head.appendChild(style);
  }, []);

  /* ---------- JSON-LD ---------- */
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: SITE.brand,
    url: SITE.domain,
    telephone: SITE.phone,
    address: {
      "@type": "PostalAddress",
      streetAddress: SITE.addressLine,
      addressLocality: "Singapore",
      postalCode: "757700",
      addressCountry: "SG",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: SITE.geo.lat,
      longitude: SITE.geo.lng,
    },
    areaServed: "Singapore",
    image: `${SITE.domain}/og.jpg`,
  };

  /* ---------- HERO SLIDES ---------- */
  const slides = useMemo(
    () => [
      {
        title: "Awning & Shade Solutions",
        subtitle: "Retractable • Loop • Fixed Awning",
        img: "/images/Awning-Shade-Solutions.png",
      },
      {
        title: "Roofing & Outdoor Extensions",
        subtitle: "Polycarbonate • ACP • Metal Structure",
        img: "/images/glass-3.jpg",
      },
      {
        title: "Glass Canopy & Shelter",
        subtitle: "Entrance • Walkway • Car Porch",
        img: "/images/Aluminium-composite-pane-scaled.jpg",
      },
    ],
    []
  );

  const quickChips = [
    "Awning Singapore",
    "Retractable Awning",
    "Glass Canopy Shelter",
    "Polycarbonate / ACP Roof",
    "Zip Track & Roller Blind",
    "Aluminium Ceiling",
    "Metal Works",
    "Renovation",
  ];

  const whyCards = [
    {
      icon: IconShield,
      title: "Built for Singapore Weather",
      desc: "UV + rain + wind — strong structure & neat sealing.",
    },
    {
      icon: IconWrench,
      title: "Custom Design + Fabrication",
      desc: "Site measurement → proposal → fabrication → installation.",
    },
    {
      icon: IconBolt,
      title: "Fast Response & Timeline",
      desc: "Practical options with clear budget and timeline guidance.",
    },
    {
      icon: IconChat,
      title: "After-sales Support",
      desc: "Responsive support for adjustments and maintenance advice.",
    },
  ];

  const industries = [
    {
      icon: IconHome,
      title: "Residential",
      desc: "HDB, condo, landed property—balcony, patio and car porch solutions.",
    },
    {
      icon: IconBuilding,
      title: "Commercial",
      desc: "Shopfront, walkway, entrance canopy and shade for businesses.",
    },
    {
      icon: IconFactory,
      title: "Industrial",
      desc: "Warehouse, factory roofing extension, metal works and shelter.",
    },
    {
      icon: IconLayers,
      title: "Public / Outdoor",
      desc: "Shelter and shade solutions for outdoor exposed areas.",
    },
  ];

  const materials = [
    { icon: IconLayers, k: "Polycarbonate", v: "Durable, light transmission, weather resistant." },
    { icon: IconShield, k: "Aluminium", v: "Rust-resistant, neat finishing and long life." },
    { icon: IconBolt, k: "ACP Roofing", v: "Modern look, strong panel system for outdoor." },
    { icon: IconCheckCircle, k: "Glass Canopy", v: "Premium entrance & walkway shelter solution." },
    { icon: IconWrench, k: "MS / GI Structure", v: "Strong structural frame for heavy duty work." },
    { icon: IconChat, k: "Zip Track Fabric", v: "Wind-resistant shade for balcony/patio use." },
  ];

  const workSteps = [
    { t: "Site Survey", d: "Measure, check fixing points, drainage and safety requirements." },
    { t: "Design & Quotation", d: "Recommend materials, structure type and provide pricing." },
    { t: "Fabrication", d: "Precision cut, welding, finishing and quality checks." },
    { t: "Installation", d: "Alignment, sealing, anchor fixing and final handover." },
  ];

  /* ===== Testimonials (running) ===== */
  const testimonials = [
    {
      name: "Jason Lim",
      role: "Homeowner – Condo Balcony",
      quote:
        "Very professional from survey to installation. The Zip Track feels premium and the finishing is neat.",
      rating: 5,
      img: "https://i.pravatar.cc/120?img=12",
    },
    {
      name: "Aisha Rahman",
      role: "Retail Shop Owner",
      quote:
        "We installed a canopy shelter for the entrance. Strong structure, clean look, and the team was punctual.",
      rating: 5,
      img: "https://i.pravatar.cc/120?img=32",
    },
    {
      name: "Daniel Tan",
      role: "Facilities Executive",
      quote:
        "Clear quotation and practical material suggestions for Singapore weather. Installation was smooth and safe.",
      rating: 5,
      img: "https://i.pravatar.cc/120?img=56",
    },
    {
      name: "Mei Ling",
      role: "Condo Management",
      quote:
        "Good workmanship and clean finishing. Communication was clear and timeline was realistic.",
      rating: 5,
      img: "https://i.pravatar.cc/120?img=47",
    },
  ];

  /* ===== Best-practice FAQ ===== */
  const faqs = [
    {
      q: "Which awning types do you install in Singapore?",
      a: "We install retractable awnings, loop awnings, fixed awnings, and custom shade solutions based on site conditions, wind exposure, and budget.",
    },
    {
      q: "Do you provide a site survey before quotation?",
      a: "Yes. A site survey is recommended for accurate fixing points, drainage considerations, and structural safety.",
    },
    {
      q: "What roofing materials are available?",
      a: "Common options include polycarbonate roofing, ACP roofing, aluminium fluted roofing, zink roofing, and glass canopy shelters (site-dependent).",
    },
    {
      q: "Can you install outdoor Zip Track and roller blinds?",
      a: "Yes. We supply and install outdoor Zip Track systems and roller blinds for balconies/patios to control sun, rain, and privacy.",
    },
    {
      q: "How long does installation usually take?",
      a: "It depends on size and complexity. Many standard installations can be completed within 1–3 days after fabrication is ready.",
    },
    {
      q: "Do you provide warranty and after-sales support?",
      a: "Yes. Warranty depends on material/system type and scope. We also provide after-sales guidance and support for adjustments.",
    },
    {
      q: "Do you handle removal and replacement of old awnings/roofing?",
      a: "Yes. We can remove old structures and replace with new systems, subject to site inspection and safe dismantling requirements.",
    },
    {
      q: "How do I get a fast quote?",
      a: "Send your location, rough size (width × projection), preferred material/type, and photos. We’ll respond quickly and schedule a survey if needed.",
    },
  ];

  /* ---------- slider ---------- */
  const [active, setActive] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setActive((p) => (p + 1) % slides.length), 4500);
    return () => clearInterval(t);
  }, [slides.length]);
  const prev = () => setActive((p) => (p - 1 + slides.length) % slides.length);
  const next = () => setActive((p) => (p + 1) % slides.length);

  /* ---------- FAQ accordion ---------- */
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>

      {/* ================= FULL WIDTH HERO BANNER ================= */}
      <section className="relative h-[90vh] min-h-[560px] w-full overflow-hidden">
        {slides.map((s, idx) => (
          <div
            key={s.title}
            className={classNames(
              "absolute inset-0 transition-opacity duration-700",
              idx === active ? "opacity-100" : "opacity-0"
            )}
          >
            <img
              src={s.img}
              alt={s.title}
              className="h-full w-full object-cover"
              loading={idx === active ? "eager" : "lazy"}
            />


            <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/45 to-black/20" />
          </div>
        ))}

        <div className="relative z-10 h-full flex items-center">
          <div className="max-w-6xl mx-auto px-4">
            <span className="inline-flex items-center gap-2 rounded-full bg-white/90 px-4 py-1 text-xs font-extrabold text-slate-800">
              Singapore • Design • Fabrication • Installation
            </span>

            <h1 className="mt-4 text-4xl md:text-6xl font-extrabold text-white leading-tight">
              Shade, Shelter & Roofing <br />
              <span className="text-blue-400">Solutions in Singapore</span>
            </h1>

            <p className="mt-5 max-w-2xl text-white/90 text-lg leading-relaxed">
              Professional awning, roofing, glass canopy, zip track, aluminium ceiling
              and metal works for residential, commercial & industrial projects — engineered for Singapore weather.
            </p>

            <div className="mt-6 flex flex-wrap gap-2">
              {quickChips.map((c) => (
                <span
                  key={c}
                  className="text-xs font-semibold px-3 py-1 rounded-full bg-white/10 text-white border border-white/20 backdrop-blur"
                >
                  {c}
                </span>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap gap-4">
              <Link
                to="/services"
                className="px-6 py-3 rounded-2xl bg-blue-600 text-white font-extrabold hover:opacity-95 shadow"
              >
                View Services
              </Link>

              <Link
                to="/contact"
                className="px-6 py-3 rounded-2xl bg-white text-slate-900 font-extrabold hover:bg-slate-100 shadow"
              >
                Get Free Quote
              </Link>

              <a
                href={`tel:${SITE.phone}`}
                className="px-6 py-3 rounded-2xl border border-white/40 text-white font-extrabold hover:bg-white/10"
              >
                Call {SITE.phone}
              </a>
            </div>

            <div className="mt-6 text-sm text-white/80">
              Office: <b className="text-white">{SITE.addressLine}, {SITE.cityLine}</b>
            </div>
          </div>
        </div>

        <button
          onClick={prev}
          className="absolute left-5 top-1/2 -translate-y-1/2 z-20 bg-white/85 p-2 rounded-full shadow hover:bg-white"
          aria-label="Previous slide"
        >
          <IconArrowLeft className="h-5 w-5 text-black" />
        </button>

        <button
          onClick={next}
          className="absolute right-5 top-1/2 -translate-y-1/2 z-20 bg-white/85 p-2 rounded-full shadow hover:bg-white"
          aria-label="Next slide"
        >
          <IconArrowRight className="h-5 w-5 text-black" />
        </button>

        <div className="absolute bottom-7 left-1/2 -translate-x-1/2 flex gap-2 z-20">
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              className={classNames(
                "h-3 w-3 rounded-full transition",
                active === i ? "bg-white" : "bg-white/40 hover:bg-white/70"
              )}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>
      </section>

      {/* ================= WHY US ================= */}
      <section className="max-w-6xl mx-auto px-4 py-16">
        <h2 className="text-3xl font-extrabold text-slate-900 text-center">
          Why Choose {SITE.brand}
        </h2>
        <p className="mt-3 text-center text-slate-600 max-w-2xl mx-auto">
          We focus on durability, safety and clean finishing — not just installation.
        </p>

        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {whyCards.map((c) => {
            const Icon = c.icon;
            return (
              <div
                key={c.title}
                className="group rounded-3xl border border-slate-200 bg-white p-6 shadow-sm hover:shadow-xl transition"
              >
                <div className="h-14 w-14 rounded-2xl bg-blue-600/10 flex items-center justify-center mb-4">
                  <Icon className="h-7 w-7 text-blue-600" />
                </div>

                <h3 className="font-extrabold text-lg text-slate-900">{c.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{c.desc}</p>
              </div>
            );
          })}
        </div>
      </section>

      {/* ================= SERVICES (ICON BASED, NO IMAGES) ================= */}
<section className="bg-slate-50 border-y">
  <div className="max-w-6xl mx-auto px-4 py-16">
    <div className="flex items-end justify-between gap-4 flex-wrap">
      <div>
        <h2 className="text-3xl font-extrabold text-slate-900">Our Core Services</h2>
        <p className="text-slate-600 mt-2">
          Awnings, roofing, shade systems, ceilings, blinds and metal works—one-stop solution.
        </p>
      </div>
      <Link to="/services" className="text-blue-600 font-extrabold hover:underline">
        View all →
      </Link>
    </div>

    {/* ICON MAP (slug -> icon) */}
    {(() => {
      const ICON = {
        "retractable-awning": "☀️",
        "loop-awning": "🏬",
        "rooftop-awnings": "🏠",
        "glass-canopy": "🧱",
        "sunshade": "🌤️",
        "outdoor-zip-track": "🪟",
        "roller-blind": "🧵",
        "acp-roof": "🧩",
        "polycarbonate-roof": "🏗️",
        "aluminium-fluted-roof": "📐",
        "zinc-roof": "🔩",
        "pvc-ceiling": "🧼",
        "aluminum-ceiling": "🏢",
        "metal-work": "⚙️",
        "wooden-trellis": "🌿",
        "wooden-decking": "🪵",
        renovation: "🛠️",
      };

      return (
        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.slice(0, 6).map((s) => (
            <Link
              key={s.slug}
              to={`/services/${s.slug}`}
              className="group rounded-3xl border border-slate-200 bg-white p-6 shadow-sm hover:shadow-lg transition"
            >
              {/* Icon */}
              <div className="flex items-start gap-4">
                <div className="h-12 w-12 rounded-2xl bg-slate-100 flex items-center justify-center text-2xl group-hover:scale-105 transition">
                  {ICON[s.slug] || "✅"}
                </div>

                <div className="flex-1">
                  <h3 className="text-lg font-extrabold text-slate-900 group-hover:text-blue-700 transition">
                    {s.title}
                  </h3>
                  <p className="mt-1 text-sm text-slate-600 leading-relaxed">
                    {s.desc}
                  </p>

                  <div className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-blue-600 group-hover:text-blue-700">
                    View details <span aria-hidden>→</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      );
    })()}
  </div>
</section>

      {/* ================= INDUSTRIES ================= */}
      <section className="max-w-6xl mx-auto px-4 py-16">
        <h2 className="text-3xl font-extrabold text-slate-900 text-center">Industries We Serve</h2>
        <p className="mt-3 text-center text-slate-600 max-w-2xl mx-auto">
          From homes to factories — we deliver shade and roofing solutions across Singapore.
        </p>

        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {industries.map((it) => {
            const Icon = it.icon;
            return (
              <div
                key={it.title}
                className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm hover:shadow-xl transition"
              >
                <div className="h-14 w-14 rounded-2xl bg-slate-900/5 flex items-center justify-center mb-4">
                  <Icon className="h-7 w-7 text-slate-900" />
                </div>
                <div className="font-extrabold text-slate-900">{it.title}</div>
                <div className="mt-2 text-sm text-slate-600">{it.desc}</div>
              </div>
            );
          })}
        </div>
      </section>

      {/* ================= MATERIALS (Premium) ================= */}
      <section className="relative bg-white border-y overflow-hidden">
        <div className="pointer-events-none absolute -top-32 right-[-10%] h-96 w-96 rounded-full bg-blue-600/10 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-32 left-[-10%] h-96 w-96 rounded-full bg-slate-900/10 blur-3xl" />

        <div className="relative max-w-6xl mx-auto px-4 py-16">
          <div className="flex items-end justify-between gap-6 flex-wrap">
            <div>
              <h2 className="text-3xl font-extrabold text-slate-900">Materials We Use</h2>
              <p className="mt-2 text-slate-600 max-w-2xl">
                We recommend materials based on weather, safety, budget and design finishing — for long life and clean look.
              </p>
            </div>
            <div className="text-sm font-semibold text-slate-600">
              Singapore weather-ready • UV • Rain • Wind
            </div>
          </div>

          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {materials.map((m) => {
              const Ico = m.icon;
              return (
                <div
                  key={m.k}
                  className="group relative rounded-3xl border border-slate-200 bg-white p-6 shadow-sm hover:shadow-xl transition"
                >
                  <div className="absolute inset-x-0 top-0 h-1 rounded-t-3xl bg-gradient-to-r from-blue-600 to-slate-900 opacity-70" />

                  <div className="flex items-start gap-4">
                    <div className="h-12 w-12 rounded-2xl bg-blue-600/10 text-blue-700 flex items-center justify-center group-hover:scale-105 transition">
                      <Ico className="h-6 w-6" />
                    </div>

                    <div className="flex-1">
                      <div className="font-extrabold text-slate-900 text-lg">{m.k}</div>
                      <div className="mt-2 text-sm text-slate-600 leading-relaxed">{m.v}</div>

                      <div className="mt-4 flex flex-wrap gap-2">
                        <span className="text-xs font-semibold px-3 py-1 rounded-full bg-slate-100 text-slate-700">
                          Weather resistant
                        </span>
                        <span className="text-xs font-semibold px-3 py-1 rounded-full bg-slate-100 text-slate-700">
                          Clean finishing
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="pointer-events-none absolute inset-0 rounded-3xl ring-0 ring-blue-600/20 group-hover:ring-4 transition" />
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ================= HOW WE WORK (Premium timeline) ================= */}
      <section className="relative max-w-6xl mx-auto px-4 py-16">
        <div className="flex items-end justify-between gap-6 flex-wrap">
          <div>
            <h2 className="text-3xl font-extrabold text-slate-900">How We Work</h2>
            <p className="mt-2 text-slate-600 max-w-2xl">
              A clear process that ensures safety, quality and neat finishing — from survey to handover.
            </p>
          </div>

          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-5 py-3 rounded-2xl bg-slate-900 text-white font-extrabold hover:opacity-95"
          >
            <IconClipboard className="h-5 w-5" />
            Book Site Survey
          </Link>
        </div>

        <div className="mt-10 relative">
          <div className="hidden lg:block absolute left-0 right-0 top-1/2 -translate-y-1/2 h-px bg-slate-200" />

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {workSteps.map((s, i) => (
              <div
                key={s.t}
                className="group relative rounded-3xl border border-slate-200 bg-white p-6 shadow-sm hover:shadow-xl transition"
              >
                <div className="flex items-center justify-between">
                  <div className="inline-flex items-center gap-2 text-xs font-extrabold text-blue-600">
                    <span className="h-7 w-7 rounded-full bg-blue-600/10 text-blue-700 flex items-center justify-center">
                      {i + 1}
                    </span>
                    STEP {i + 1}
                  </div>

                  <div className="h-10 w-10 rounded-2xl bg-slate-900/5 flex items-center justify-center group-hover:scale-105 transition">
                    {i === 0 ? <IconPin className="h-5 w-5 text-slate-900" /> : null}
                    {i === 1 ? <IconClipboard className="h-5 w-5 text-slate-900" /> : null}
                    {i === 2 ? <IconWrench className="h-5 w-5 text-slate-900" /> : null}
                    {i === 3 ? <IconCheckCircle className="h-5 w-5 text-slate-900" /> : null}
                  </div>
                </div>

                <div className="mt-3 font-extrabold text-slate-900 text-lg">{s.t}</div>
                <div className="mt-2 text-sm text-slate-600 leading-relaxed">{s.d}</div>

                <div className="mt-5 h-px bg-slate-100" />
                <div className="mt-4 text-xs text-slate-500">
                  ✔ Quality check included • ✔ Clean finishing
                </div>

                <div className="pointer-events-none absolute inset-0 rounded-3xl ring-0 ring-blue-600/20 group-hover:ring-4 transition" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= RUNNING TESTIMONIALS (Works) ================= */}
      <section className="relative bg-white border-t overflow-hidden">
        <div className="max-w-6xl mx-auto px-4 py-16">
          <div className="flex items-end justify-between gap-6 flex-wrap">
            <div>
              <h2 className="text-3xl font-extrabold text-slate-900">What Customers Say</h2>
              <p className="mt-2 text-slate-600 max-w-2xl">
                Social proof matters. Running reviews help visitors trust your workmanship, finishing and support.
              </p>
            </div>

            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-2xl bg-slate-900 text-white font-extrabold hover:opacity-95"
            >
              <IconClipboard className="h-5 w-5" />
              Get Quotation
            </Link>
          </div>

          {/* fade edges */}
          <div className="relative mt-10 dleeMarqueeWrap">
            <div className="pointer-events-none absolute left-0 top-0 h-full w-24 bg-gradient-to-r from-white to-transparent z-10" />
            <div className="pointer-events-none absolute right-0 top-0 h-full w-24 bg-gradient-to-l from-white to-transparent z-10" />

            <div className="overflow-hidden">
              <div className="dleeMarqueeTrack">
                {[...testimonials, ...testimonials].map((t, idx) => (
                  <div
                    key={idx}
                    className="w-[320px] shrink-0 rounded-3xl border border-slate-200 bg-white p-6 shadow-sm hover:shadow-xl transition"
                  >
                    <div className="flex gap-1 text-amber-500">
                      {Array.from({ length: t.rating }).map((_, i) => (
                        <IconStar key={i} className="h-5 w-5" />
                      ))}
                    </div>

                    <p className="mt-4 text-sm text-slate-700 leading-relaxed">“{t.quote}”</p>

                    <div className="mt-6 flex items-center gap-3">
                      <img
                        src={t.img}
                        alt={t.name}
                        className="h-12 w-12 rounded-full object-cover border"
                        loading="lazy"
                      />
                      <div>
                        <div className="font-extrabold text-slate-900">{t.name}</div>
                        <div className="text-xs text-slate-600">{t.role}</div>
                      </div>
                    </div>

                    <div className="pointer-events-none absolute inset-0 rounded-3xl ring-0 ring-blue-600/15" />
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-10 grid sm:grid-cols-3 gap-4 text-center">
              {["Neat Finishing", "Strong Structure", "Reliable Support"].map((x) => (
                <div
                  key={x}
                  className="rounded-3xl border border-slate-200 bg-slate-50 p-5 font-extrabold text-slate-900"
                >
                  {x}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ================= FAQ (Premium) ================= */}
      <section className="relative bg-slate-50 border-t overflow-hidden">
        <div className="pointer-events-none absolute -top-24 left-[-10%] h-80 w-80 rounded-full bg-blue-600/10 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-24 right-[-10%] h-80 w-80 rounded-full bg-slate-900/10 blur-3xl" />

        <div className="relative max-w-6xl mx-auto px-4 py-16">
          <div className="flex items-end justify-between gap-6 flex-wrap">
            <div>
              <h2 className="text-3xl font-extrabold text-slate-900">Frequently Asked Questions</h2>
              <p className="mt-2 text-slate-600 max-w-2xl">
                Quick answers about awnings, roofing, shelters, Zip Track and the installation process.
              </p>
            </div>

            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-2xl bg-slate-900 text-white font-extrabold hover:opacity-95"
            >
              <IconChat className="h-5 w-5" />
              Ask a Question
            </Link>
          </div>

          <div className="mt-10 grid lg:grid-cols-2 gap-6">
            {faqs.map((f, i) => {
              const opened = openFaq === i;
              return (
                <div
                  key={f.q}
                  className={classNames(
                    "rounded-3xl border bg-white shadow-sm transition overflow-hidden",
                    opened ? "border-blue-200 shadow-lg" : "border-slate-200"
                  )}
                >
                  <button
                    type="button"
                    onClick={() => setOpenFaq(opened ? -1 : i)}
                    className="w-full text-left p-6 flex items-start gap-4"
                    aria-expanded={opened}
                  >
                    <div className="h-12 w-12 rounded-2xl bg-blue-600/10 text-blue-700 flex items-center justify-center shrink-0">
                      <IconQuestion className="h-6 w-6" />
                    </div>

                    <div className="flex-1">
                      <div className="font-extrabold text-slate-900">{f.q}</div>
                      <div
                        className={classNames(
                          "grid transition-all duration-300",
                          opened ? "grid-rows-[1fr] mt-3" : "grid-rows-[0fr]"
                        )}
                      >
                        <div className="overflow-hidden text-sm text-slate-600 leading-relaxed">
                          {f.a}
                        </div>
                      </div>
                    </div>

                    <IconChevronDown
                      className={classNames(
                        "h-5 w-5 text-slate-600 mt-1 transition",
                        opened ? "rotate-180" : ""
                      )}
                    />
                  </button>
                </div>
              );
            })}
          </div>

          <div className="mt-10 rounded-3xl border border-slate-200 bg-white p-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
              <div className="font-extrabold text-slate-900">Still have questions?</div>
              <div className="text-sm text-slate-600 mt-1">
                Share your location + photos + rough size. We’ll guide you with the best option for Singapore weather.
              </div>
            </div>
            <div className="flex gap-3 flex-wrap">
              <a
                href={`tel:${SITE.phone}`}
                className="px-5 py-3 rounded-2xl bg-blue-600 text-white font-extrabold hover:opacity-95"
              >
                Call {SITE.phone}
              </a>
              <Link
                to="/contact"
                className="px-5 py-3 rounded-2xl border font-extrabold text-slate-900 hover:bg-slate-50"
              >
                Contact Form
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ================= CTA ================= */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900 via-slate-900 to-blue-900" />
        <div className="relative max-w-6xl mx-auto px-4 py-14 text-white grid md:grid-cols-2 gap-6 items-center">
          <div>
            <h3 className="text-3xl font-extrabold">Get a Free Site Survey & Quote</h3>
            <p className="text-white/80 mt-2">
              Send location + rough size + preferred material. We will reply quickly with best options.
            </p>
          </div>
          <div className="md:text-right flex md:justify-end gap-3 flex-wrap">
            <a
              href={`tel:${SITE.phone}`}
              className="inline-block px-6 py-3 rounded-2xl bg-white text-slate-900 font-extrabold hover:opacity-95"
            >
              Call {SITE.phone}
            </a>
            <Link
              to="/contact"
              className="inline-block px-6 py-3 rounded-2xl border border-white/25 text-white font-extrabold hover:bg-white/10"
            >
              Contact Form
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
